import { render, staticRenderFns } from "./index.vue?vue&type=template&id=383c2d6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=383c2d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c2d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383c2d6c')) {
      api.createRecord('383c2d6c', component.options)
    } else {
      api.reload('383c2d6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=383c2d6c&scoped=true&", function () {
      api.rerender('383c2d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/index.vue"
export default component.exports